import React from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";

export default function OfflinePage() {
  var handleRetry = function () {
    window.location.reload();
  };
  var focusableResult = useFocusable({
    focusKey: "offline-retry",
    forceFocus: true,
    onEnterPress: handleRetry,
  });
  var ref = focusableResult.ref;
  var focused = focusableResult.focused;
  var focusSelf = focusableResult.focusSelf;

  React.useEffect(function () {
    focusSelf({ skipScroll: true });
  }, [focusSelf]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "#121212",
        color: "#fff",
        fontFamily: "AnjomanMax, sans-serif",
        direction: "rtl",
        padding: 40,
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: 32, marginBottom: 16 }}>
        اتصال به اینترنت برقرار نیست
      </h1>
      <p
        style={{
          fontSize: 18,
          color: "rgba(255,255,255,0.7)",
          marginBottom: 32,
        }}
      >
        لطفاً اتصال اینترنت خود را بررسی کنید
      </p>
      <button
        ref={ref}
        type="button"
        onClick={handleRetry}
        onMouseEnter={focusSelf}
        className={focused ? "is-focused" : ""}
        style={{
          padding: "16px 48px",
          background: focused ? "#a90000" : "#850000",
          color: "#fff",
          border: focused ? "4px solid #fff" : "4px solid transparent",
          borderRadius: 8,
          fontSize: 18,
          cursor: "pointer",
          boxSizing: "border-box",
        }}
      >
        تلاش مجدد
      </button>
    </div>
  );
}
